module.exports = __webpack_public_path__ + "img/Sunrice.440f3449.png";